export default "__VITE_ASSET__7ea2d69d__"